function getResourceType(resourceType: string) {
  if (resourceType === 'Theme') return '模板';
  if (resourceType === 'Extension') return '插件';
  if (resourceType === 'Service') return 'VIP服务';
  return '';
}

export default getResourceType;
